import { render, staticRenderFns } from "./ImportFavourites.vue?vue&type=template&id=2d7f7f85"
import script from "./ImportFavourites.vue?vue&type=script&lang=js"
export * from "./ImportFavourites.vue?vue&type=script&lang=js"
import style0 from "./ImportFavourites.vue?vue&type=style&index=0&id=2d7f7f85&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7f7f85')) {
      api.createRecord('2d7f7f85', component.options)
    } else {
      api.reload('2d7f7f85', component.options)
    }
    module.hot.accept("./ImportFavourites.vue?vue&type=template&id=2d7f7f85", function () {
      api.rerender('2d7f7f85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ImportFavourites.vue"
export default component.exports